/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.30/esri/copyright.txt for details.
*/
import{AComputedField as e}from"./AComputedField.js";class r extends e{constructor(e){super(),this._value=e}resize(e){}read(e,r){return this._value}readWithDefault(e,r,t){return this._value}referencesScale(){return!1}referencesGeometry(){return!1}}export{r as DictionaryValue};
